import { APP_BUILD_ENV } from '../constants/envs';
import { storeKey, validStorageKeys } from '../constants/localStorage';

const $$storage = window.localStorage;

type Store = Record<string, unknown>;

/**
 * Retrieves the stored value or the entire storage object.
 * @returns The entire storage object or the value associated with the key.
 */
export const getStorage = (): Store => {
  const raw = $$storage.getItem(storeKey);
  const storeObj = JSON.parse(raw ?? '{}') as Store;

  return validStorageKeys.reduce((acc, key) => {
    const value = storeObj[key];
    return value !== undefined ? { ...acc, [key]: value } : acc;
  }, {} as Store);
};

/**
 * Sets a parameter in the storage.
 * @param paramName - The key to set in the storage.
 * @param value - The value to set for the key.
 */
export const setStoreParam = (paramName: string, value: number | string | boolean | unknown): void => {
  if (validStorageKeys.includes(paramName)) {
    $$storage.setItem(
      storeKey,
      JSON.stringify({
        ...getStorage(),
        [paramName]: value,
      }),
    );
  } else if (APP_BUILD_ENV === 'dev-local') {
    throw Error(`Store parameter ${paramName} is invalid, please add it to the *validStorageKeys* array`);
  }
};

/**
 * Removes a parameter from the storage by setting it to undefined.
 * @param paramName - The key to remove from the storage.
 */
export const removeStoreParam = (paramName: string): void => {
  const store = getStorage() as Store;
  store[paramName] = undefined;
  $$storage.setItem(storeKey, JSON.stringify(store));
};
